<template>
  <section>
    <div class="tab-wrap">
      <button type="button" class="tab-item" :class="{ active: reqData.creditStatus === '0' }" @click="changeListType" value="0">환전신청</button>
      <button type="button" class="tab-item" :class="{ active: reqData.creditStatus === '2' }" @click="changeListType" value="2">환전대기</button>
      <button type="button" class="tab-item" :class="{ active: reqData.creditStatus === '1' }" @click="changeListType" value="1">환전완료</button>
    </div>
    <div class="searchBar">
      <div class="box-ui-select searchbar-content">

        <div class="title"><span>신청날짜</span> :</div>
        <date-selector :class="'searchbar-content'" @setStartDate="setStartDate" @setEndDate="setEndDate" :startDefault="startDefault" :endDefault="endDefault" />
      </div>
      <div class="box-ui-select searchbar-content">
        <div class="title">
          <span>아이디</span> :
        </div>
        <input type="text" class="mr-5" v-model="reqData.memId" :placeholder="'아이디'" />
        <button class="btn-search" type="button" @click="pageSeach">
          검색
        </button>
      </div>
    </div>
    <div class="main-contents-wrapper">
      <div class="table-wrapper">
        <table class="mainTable">
          <table-head :headInfo="headInfo" />
          <tbody v-if="applyList.length !== 0">
            <tr v-for="(item, idx) in applyList" :key="idx">
              <td style="width: 10%">
                <span
                  ><a href="#" class="userDetailOpen fc-id">{{ item.regId }}</a></span
                >
              </td>
              <td></td>
              <td>
                <span class="money-apply" v-if="item.precreditAmt">{{ item.precreditAmt }}</span>
                <span v-else>-</span>
              </td>
              <td>
                <span class="money-apply">{{ Math.abs(item.creditAmt) }}</span>
              </td>
              <td>
                <span class="money-apply">{{ Number(item.creditRate).toFixed(2) }}%</span>
              </td>
              <td>
                <span>{{ Math.abs(item.creditAmt)*(item.creditRate*0.01) }}</span>
              </td>
               <td>
                <!-- <span   class="money-apply">{{ item.realCreditAmt }}</span>-->
                <span>-</span>
              </td>
              <td style="width: 15%">
                <span>{{ item.regDate }}</span>
              </td>
              <td style="width: 15%">
                <span v-if="item.creditStatus==='1'||item.creditStatus==='2'">{{ item.regDate }}</span>
                <span v-else>-</span>
              </td>
              <td class="statusColor" :class="item.statusClass">{{ item.statusText }}</td>
              <td style="width: 8%">
                <div class="status-change-btn-wrap">
                  <button class="btn-innerTable btn-status-change wait" type="button" v-if="item.creditStatus == '0'" @click="statusChange(item.creditIdx, item.creditAmt, item.creditType, item.creditStatus)">확인</button>
                  <button class="btn-innerTable btn-status-change refuse" type="button" value="1" :data-list-idx="idx" :data-cash-idx="item.cashIdx" v-if="item.creditStatus == '2'" @click="statusChange(item.creditIdx, item.creditAmt, item.creditType, item.creditStatus)">환전</button>
                  <span v-if="item.creditStatus == '1'">-</span>
                </div>
              </td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr>
              <td colspan="14">
                <span class="notice-tableDataEmpty">데이터가 없습니다</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <pagination v-if="applyList.length !== 0" @goPage="setTableData" :pageNum="pageInfo.page" :pageSize="pageInfo.count_per_list" :totalCount="pageInfo.tatal_list_count" />
  </section>
</template>

<script>
import SearchFilter from "@/components/common/SearchFilter";
import DateSelector from "@/components/common/DateSelector";
import TableHead from "@/components/main/table/Head.vue";
import { creditApplyList, creditUpdateStatus } from "@/api/credit.js";
import Pagination from "@/components/common/Pagination";
import UiCheck from "@/components/ui/UiCheckSet";

export default {
  name: "CreditExchange",
  components: {
    TableHead,
    DateSelector,
    SearchFilter,
    Pagination,
    UiCheck
  },
  props: {
    status: {
      type: String,
      default: "0"
    }
  },
  watch: {
    $route: {
      async handler() {
        const status = this.$route.params.status;
        console.log(status);
        this.setTableData(1, status);
      }
    }
  },
  data: function () {
    return {
      tableName: "Basic",
      headInfo: {
        fstColumn: false,
        dataList: ["companyId", "siteId", "currentPT", "ptExcahngeAmt", "feeRate", "ptRealMoney", "postPT", "applyDate", "updDate", "status", "statusChange"]
      },
      srchFiltersProp: {
        selectOptions: [
          {
            useAll: true,
            opts: [
              {
                title: "id"
              }
            ]
          }
        ]
      },
      reqData: {
        creditStatus: "0",
        page: 1,
        creditType: "-1",
        count_per_list: "30"
      },
      pageInfo: {},
      applyList: [],
      checkList: [
        {
          val: "0",
          text: "요청"
        },
        {
          val: "1",
          text: "대기"
        },
        {
          val: "2",
          text: "완료"
        }
      ]
    };
  },
  methods: {
    openWindow() {
      window.open("/user/userDetail", "userDetail", "top=0,left=150,scrollbars=no,resizable=no,width=1480,height=885,status=no");
    },
    async getCreditApplyList(pageNum) {
      if (pageNum) {
        this.reqData.page = pageNum;
      }
      const data = this.reqData;
      return await creditApplyList(data);
    },
    async changeListType(evt) {
      const target = evt.target;
      const chooseType = target.value;
      this.reqData.creditStatus = chooseType;
      this.setTableData(1);
    },
    async setTableData(pageNum, status) {
      if (status) {
        this.reqData.creditStatus = status;
      }
      const res = await this.getCreditApplyList(pageNum);
      const applyList = res.data.list;
      const pageInfo = res.data.pageInfo;
      if (pageInfo) {
        this.pageInfo = pageInfo;
      }
      this.applyList = this.dataConvertor(applyList);
    },
    creditPayment(dataObj) {
      let _creditAmt = prompt(`알 지급 금액`, dataObj.creditAmt);
      const trigger = {
        msg: "",
        prog: false
      };
      if (isNaN(_creditAmt)) {
        trigger.msg = "숫자만 입력해주세요.";
      }
      // _creditAmt = Math.abs(_creditAmt);
      // if (_creditAmt <= 0) {
      //   trigger.msg = "지급 최소 금액은 0 이상 입니다. 다시 입력해주세요.";
      // } else
      if (_creditAmt == null || _creditAmt == undefined) {
        trigger.msg = "";
      } else {
        trigger.msg = _creditAmt;
        trigger.prog = confirm(`${_creditAmt}을 환전합니다.`);
      }

      return trigger;
    },
   async statusChange(idx, creditAmt, type, status) {
      let reqData = {
        creditIdx: idx,
        creditType: type,
        creditStatus: status,
        creditAmt: creditAmt
      };
      switch (status) {
        case "0":
          reqData.creditStatus = "2";
          break;
        case "2":
          reqData.creditStatus = "1";
          const preCheck = this.creditPayment(reqData);
          if (preCheck.prog) {
            reqData.creditAmt = preCheck.msg;
          } else {
            if (preCheck.msg) {
              alert(preCheck.msg);
            }
            return;
          }
          break;
        case "1":
          (reqData.creditStatus = "1"), (reqData.creditType = "-1");
          reqData.creditAmt = "0";
          break;
      }
      const res = await creditUpdateStatus(reqData);
      this.setTableData();
      if (res.resultCode === "0") {
        if (reqData.creditStatus === "1") {
          alert("알 환전 완료");
        } else if (reqData.creditStatus === "2") {
        }
      } else {
        if (reqData.creditStatus === "1") {
          alert("알 환전에 실패 했습니다. 다시 시도해주세요.");
        } else {
          alert("알 상태 변경에 실패 했습니다. 다시 시도해주세요.");
        }
      }
    },
    dataConvertor(dataList) {
      const _dataList = dataList;
      if (!dataList.length || dataList.length === 0) {
        return _dataList;
      }
      _dataList.forEach(items => {
        const creditStatus = items.creditStatus;
        let statusText = "";
        // - 0:요청, 1:완료, 2:대기 , -1"거부
        if (creditStatus === "0") {
          statusText = "환전신청";
          items.statusClass = "apply";
        } else if (creditStatus === "1") {
          statusText = "환전완료";
          items.statusClass = "approve";
        } else if (creditStatus === "2") {
          statusText = "환전대기";
          items.statusClass = "wait";
        } else if (creditStatus === "-1") {
          statusText = "환전거절";
          items.statusClass = "refuse";
        }
        if (!items.realCreditAmt) {
          items.realCreditAmt = "-";
        }
        items.statusText = statusText;
        items.regDate = items.regDate.replace("T", " ");
        items.updDate = items.updDate.replace("T", " ");
        for (const item in items) {
          if (items[item] === "") {
            items[item] = "-";
          }
        }
      });
      return _dataList;
    }
  },
  async created() {
    this.setTableData();
  }
};
</script>

<style scoped>
.main-contents-wrapper {
  padding: 10px 0;
}
.statusColor {
  font-weight: 700;
}
.statusColor.apply {
  color: #ef8c1d;
}
.statusColor.approve {
  color: blue;
}
.statusColor.refuse {
  color: red;
}
.statusColor.wait {
  color: green;
}
</style>
